import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar";
import Navbar from "../staticView/globalComponents/Navbar";
import Footer from "../staticView/globalComponents/Footer";

function Layout() {
  useEffect(() => {
    document.body.classList.add("smile-portal-active");
    return () => {
      document.body.classList.remove("smile-portal-active");
    };
  }, []);

  return (
    <div className="w-full bg-[#16171A]">
      <div className="min-h-screen w-full flex flex-col">
        <div className="sticky top-0 z-50 w-full">
          <Navbar />
        </div>

        <div className="relative flex flex-1 w-full min-h-0">
          <Sidebar />

            <div className="flex-1 min-w-0 bg-[#16171A]">
            <main className="smile-studio-scroll-root min-h-screen overflow-y-auto overflow-x-hidden p-3 pt-[4.25rem] sm:p-4 sm:pt-16 md:px-8 md:py-[26px] md:pt-6 pb-[max(1rem,env(safe-area-inset-bottom))] max-w-full">
              <Outlet />
            </main>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Layout;
